(ns frontend.ui.component.lp-portal.report.esg.targets-and-strategy.view
  (:require
   [clojure.string :as s]
   [common.time :as c-time]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn targets-and-strategy-card
  [{:keys [rich-content-completed-at rich-content-completed-path rich-content rich-content-path] :as esg-targets-and-strategy-text}
   {:keys [edit-mode? show-draft? save-text] :as props}]
  [card
   {:title "Sustainability targets and strategy"}
   [text-content/free-text-with-modal 
    {:html-content      rich-content
     :completed-at      rich-content-completed-at
     :complete-changed! (when (and edit-mode?
                                   (fn? save-text))
                          (fn [new-content completed?]
                            (save-text rich-content-path
                                       new-content
                                       rich-content-completed-path
                                       (if completed?
                                         ""
                                         (str (c-time/now-millis))))))
     :show-draft?       show-draft?
     :can-edit?         edit-mode?
     :on-change         (when (and edit-mode?
                                   (fn? save-text))
                          #(save-text rich-content-path %))}]])
